import { Injectable } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { OrderByDirection } from 'firebase/firestore';
import {
  EventsStore,
  EventsSelectors,
} from '../../events-store';
import {EventsActions} from '../actions/events.actions';

@Injectable()
export class EventStoreFacade {
  constructor(private readonly store: Store<EventsStore.State>) {}

  fetchEventsForHorse$ = (horseId: string) => {
    return this.store.dispatch(EventsActions.loadEventsListForHorse(horseId));
  };

  getEventsForHorse$ = (
    horseId: string,
    orderDirection: OrderByDirection = 'desc'
  ) => {
    return this.store.pipe(
      select(EventsSelectors.selectEventsByHorseId(horseId,orderDirection))
    );
  };
}
